import React from "react";
import {
  Select,
  FormControl,
  MenuItem,
  createStyles,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { SortTypeData } from "../../types";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      alignItems: "center",
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

interface Props {
  sortTypeData: SortTypeData;
  handleSortChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
}

/**
 * ソート選択2
 *
 * Simple Select
 * https://material-ui.com/components/selects/#simple-select
 */
export function SortSelect(props: Props) {
  const classes = useStyles();

  //------------------------------
  // ソート
  // [State]
  const { sortTypeData } = props;
  // [Handler]
  const { handleSortChange } = props;

  const key =
    sortTypeData.item == null || sortTypeData.order
      ? ""
      : `${sortTypeData.item}-${(sortTypeData.order as unknown) as string}`;

  //--------------------
  // コンポーネント
  return (
    <div>
      <FormControl className={classes.formControl}>
        <Select
          margin="dense"
          labelId="id_sort_label"
          id="id_sort"
          value={key}
          onChange={handleSortChange}
          displayEmpty
        >
          <MenuItem value="">
            <em>評価順</em>
          </MenuItem>
          <MenuItem value="create_datetime-true">作成日時/昇順</MenuItem>
          <MenuItem value="create_datetime-false">作成日時/降順</MenuItem>
          <MenuItem value="update_datetime-true">更新日時/昇順</MenuItem>
          <MenuItem value="update_datetime-false">更新日時/降順</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
}
